export default __webpack_public_path__ + "media/images/marker-7866b9e3aa1e8eeaeaa179cb42fe6acc.svg";